import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IParticipantApplicationDocument } from '../Models/IParticipantApplicationDocument';
import { ITypedValidationResult } from '../Models/IValidationResult';

class participantApplicationDocumentService extends BaseApiService {
    public constructor() {
        super('ParticipantApplicationDocument/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByParticipantApplicationDocumentId(participantApplicationDocumentId: number, auth0Id: string): Promise<IParticipantApplicationDocument> {
        return this.httpClient.get<IParticipantApplicationDocument>(`GetByParticipantApplicationDocumentId?participantApplicationDocumentId=${participantApplicationDocumentId}&auth0Id=${auth0Id}`, participantApplicationDocumentService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getByParticipantApplicationId(participantApplicationId: number, auth0Id: string): Promise<IParticipantApplicationDocument> {
        console.log('get app doc ByParticipantApplicationId: ' + participantApplicationId);
        return this.httpClient.get<IParticipantApplicationDocument>(`GetByParticipantApplicationId?participantApplicationId=${participantApplicationId}&auth0Id=${auth0Id}`, participantApplicationDocumentService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async saveParticipantApplicationDocument(document: IParticipantApplicationDocument, auth0Id: string) {
        console.log('Updating App document');
        this.httpClient.post<ITypedValidationResult<IParticipantApplicationDocument>>(`SaveParticipantApplicationDocument?auth0Id=${auth0Id}`, document, participantApplicationDocumentService.config).catch(this.handleError.bind(this));
    }
}

export const ParticipantApplicationDocumentService: participantApplicationDocumentService = new participantApplicationDocumentService();

export function createParticipantApplicationDocument(): IParticipantApplicationDocument {
    return {
        participantApplicationDocumentId: 0,
        participantApplicationId: 0,
        documentId: 0,
        modifiedBy: '',
        modifiedDate: ''
    }; 
}